import React from "react";
import "../App.css";



const Footer = () => {
	return (
		<footer className="footer" style={{
			background: "#222",
			color: "#fff",
			padding: "32px 0 16px 0",
			textAlign: "center",
			marginTop: "40px",
			fontSize: "1rem",
			borderTop: "2px solid #ffd700"
		}}>
			<div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "48px", marginBottom: "18px" }}>
				{/* Quick Links */}
				<div>
					<h4 style={{ color: "#ffd700", marginBottom: "10px" }}>Quick Links</h4>
					<a href="/" style={{ color: "#fff", display: "block", margin: "4px 0", textDecoration: "none" }}>Home</a>
					<a href="/events" style={{ color: "#fff", display: "block", margin: "4px 0", textDecoration: "none" }}>Events</a>
					<a href="/shop" style={{ color: "#fff", display: "block", margin: "4px 0", textDecoration: "none" }}>Shop</a>
					<a href="/profile" style={{ color: "#fff", display: "block", margin: "4px 0", textDecoration: "none" }}>Profile</a>
					<a href="/register" style={{ color: "#fff", display: "block", margin: "4px 0", textDecoration: "none" }}>Register</a>
				</div>

				{/* Contact Info */}
				<div>
					<h4 style={{ color: "#ffd700", marginBottom: "10px" }}>Contact Us</h4>
					<div>Shree Rashi Jyotish</div>
					<div>Netaji Subhash Chandra Rd, Siddharth Nagar, Mulund West, Mumbai, Maharashtra, 400080</div>
					<div>Phone: <a href="tel:+918879424647" style={{ color: "#ffd700", textDecoration: "none" }}>+91 8879424647</a></div>
					<div>Email: <a href="mailto:rashijyotish8@gmail.com" style={{ color: "#ffd700", textDecoration: "none" }}>rashijyotish8@gmail.com</a></div>
					<div style={{ margin: "10px 0" }}>
						<a href="https://www.google.com/maps/place/Rashi+Jyotish/@19.1767674,72.9527535,17z" target="_blank" rel="noopener noreferrer" style={{ color: "#ffd700", textDecoration: "underline" }}>View on Google Maps</a>
					</div>
					<div style={{ color: "#ccc", fontSize: "0.95em", marginTop: "8px" }}>
						<strong>Hours:</strong> Mon - Sun: 4:00 PM - 9:00 PM
					</div>
				</div>

				{/* Social Media */}
				<div>
					<h4 style={{ color: "#ffd700", marginBottom: "10px" }}>Follow Us</h4>
					<a href="https://www.facebook.com/RaashiJyotish" target="_blank" rel="noopener noreferrer" style={{ color: "#fff", display: "block", margin: "6px 0", fontSize: "1.2em", textDecoration: "none" }}>Facebook</a>
					<a href="https://www.instagram.com/rashijyotish?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer" style={{ color: "#fff", display: "block", margin: "6px 0", fontSize: "1.2em", textDecoration: "none" }}>Instagram</a>
					<a href="https://www.youtube.com/@RASHIJYOTISH" target="_blank" rel="noopener noreferrer" style={{ color: "#fff", display: "block", margin: "6px 0", fontSize: "1.2em", textDecoration: "none" }}>YouTube</a>
				</div>
			</div>
{/*
			
			<div style={{ maxWidth: "700px", margin: "0 auto 18px auto", color: "#ccc", fontSize: "0.95em" }}>
				<p>
					We combine classical Vedic astrology with modern insights to provide clear, practical, and compassionate readings. Services include birth chart analysis, compatibility, remedies, muhurat selection, and gemstone consultation.
				</p>
			</div>
*/}
			{/* Copyright */}
			<div style={{ color: "#ffd700", fontSize: "0.95em" }}>
				&copy; {new Date().getFullYear()} Shree Rashi Jyotish. All rights reserved.
			</div>

            {/* Creator Note */}
			<div style={{ color: "#ffd700", fontSize: "0.95em" }}>
				Created by Udit Upadhyay.
			</div>
		</footer>
	);
};
// I am done with my forsaken collage. 
export default Footer;
